import {
  HttpContext,
  HttpContextToken,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { TenantScope } from '../interfaces';
import { TenantStore } from '../stores/tenant.store';

export const COMPANY_UUID_HEADER = 'X-Company-Uuid';
export const COMPANY_SCOPE_HEADER = 'X-Company-Scope';
export const ALL_TENANTS_SCOPE = 'all';

export const TENANT_SCOPE = new HttpContextToken<TenantScope>(() => 'active');

export function withAllTenants(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(TENANT_SCOPE, 'all');
}

export function withActiveTenant(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(TENANT_SCOPE, 'active');
}

export const tenantInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (!isBackendRequest(request.url)) {
    return next(request);
  }

  const tenantStore = inject(TenantStore);
  const activeTenantUuid = tenantStore.activeTenantUuid();

  if (activeTenantUuid === null) {
    return next(request);
  }

  const headers = buildTenantHeaders(activeTenantUuid, request.context.get(TENANT_SCOPE));

  return next(request.clone({ setHeaders: headers }));
};

function buildTenantHeaders(activeTenantUuid: string, scope: TenantScope): Record<string, string> {
  if (scope === 'all') {
    return {
      [COMPANY_UUID_HEADER]: activeTenantUuid,
      [COMPANY_SCOPE_HEADER]: ALL_TENANTS_SCOPE,
    };
  }

  return { [COMPANY_UUID_HEADER]: activeTenantUuid };
}

function isBackendRequest(url: string): boolean {
  const backendBases = [
    environment.apiBaseUrl,
    environment.graphqlBaseUrl,
    environment.storageBaseUrl,
    environment.materialsApiUrl,
  ].filter((base): base is string => typeof base === 'string' && base.length > 0);

  return backendBases.some((base) => url.startsWith(base));
}
